export function index(offset = 0, limit = 999) {
    if (typeof offset === 'object') {
        offset = offset.offset ?? 0;
        limit = offset.limit ?? 999;
    }
    return axios.get(route('api.manage.companies.companyLocations'),
        { params: {offset, limit} })
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.companyLocations'), data)
        .then(response => response.data);
}

export function update(locationId, data)
{
    return axios.patch(route('api.manage.companyLocations.update', { companyLocationId: locationId }), data)
        .then(response => response.data);
}

export function destroy(locationId)
{
    return axios.delete(route('api.manage.companyLocations.destroy', { companyLocationId: locationId }));
}

export function updateSort(sort)
{
    return axios.patch(route('api.manage.companies.companyLocations.sort'), {
        data: sort
    }).then(response => {
        return response.data;
    });
}
